<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>C.J. Caj was born in Winthrop, Massachusetts. He grew up with his five older sisters and a single working mother, a nurse, living in poverty. He was trained and worked as a chef in both Boston and Munich, Germany. Caj is recovering from both alcohol and drug addiction. This is the world through his eyes.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6beebad0